import React from 'react';

import styles from './ScrollLock.less';

const getClassList = () => document.body.parentNode.classList;

/**
 * **Access:**
 * ```js
 * import {ScrollLock} from '@iss/client-react-components'
 * ```
 * Locks the main scroll zone while mounted.
 * Has no rendered output.
 *
 * @class ScrollLock
 * @component
 */
export default class ScrollLock extends React.PureComponent {
  static refCount = 0;

  componentDidMount() {
    ScrollLock.refCount++;
    getClassList().add(styles.scrollLock);
  }

  componentWillUnmount() {
    ScrollLock.refCount--;

    if (ScrollLock.refCount <= 0) {
      ScrollLock.refCount = 0;
      getClassList().remove(styles.scrollLock);
    }
  }

  render() {
    return null;
  }
}
